import React from "react";

function FAQSection({ faqData, title = "Frequently Asked Questions", intro }) {
  if (!faqData || faqData.length === 0) return null;

  return (
    <section className="faq_section_internal pb-5">
      <div className="container">
        <div className="faq_heading text-center mb-5">
          <h2 className="display-4 fw-bold text-dark mb-3">{title}</h2>
          {intro && <p className="mt-3 text-secondary mx-auto fs-5" style={{ maxWidth: '800px' }}>{intro}</p>}
          <div className="mx-auto bg-danger mt-3" style={{ width: '60px', height: '4px', borderRadius: '2px' }}></div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="accordion faq-custom-accordion" id="faqAccordion">
          {faqData.map((item, i) => {
            return (
              <div className="accordion-item" key={i}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={"#collapse_" + i}
                    aria-expanded="false"
                    aria-controls={"collapse_" + i}
                    dangerouslySetInnerHTML={{
                      __html: item.title ? (
                        item.title.replaceAll(
                          "OtoBix",
                          `<span class="otobixcls"><span class="redtext">Oto</span><span class="bluetext">Bix</span></span>`
                        )
                      ) : (
                        ""
                      ),
                    }}
                  ></button>
                </h2>
                <div
                  id={"collapse_" + i}
                  className="accordion-collapse collapse"
                  data-bs-parent="#faqAccordion"
                >
                  <div
                    className="accordion-body"
                    dangerouslySetInnerHTML={{
                      __html: item.description ? (
                        item.description.replaceAll(
                          "OtoBix",
                          `<span class="otobixcls"><span class="redtext">Oto</span><span class="bluetext">Bix</span></span>`
                        )
                      ) : (
                        ""
                      ),
                    }}
                  ></div>
                </div>
              </div>
            );
          })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQSection;
